import { coreApi } from "./coreApi";

const financialTransactionsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getFinancialTransactions: builder.query({
      query: (query) => `/accounting/reports/general-ledger?${query}`,
    }),
  }),
});

export const { useGetFinancialTransactionsQuery, useLazyGetFinancialTransactionsQuery } =
  financialTransactionsApi;
